var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"profile-wrap"},[_c('div',{staticClass:"profile-bar"},[(this.$root.user.name)?_c('div',{staticClass:"avatar-wrap"},[_c('i',{staticClass:"dashboard-icon icon-profile"}),_vm._v(_vm._s(this.$root.user.name)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }